import NotabeneVASPListResource from './vasp-list';

export default function NotabeneResource({ base }) {
  return {
    VASPList: NotabeneVASPListResource({ base }),
  };
}
